<template>
  <v-row>
    <v-col>
      <v-container class="balance-callout-background drop-shadow">
        <v-row>
          <v-col cols="2"
                 sm="1"
                 class="no-print balance-callout-icon-column">
            <v-avatar class="balance-info-icon">
              <v-icon>mdi-information-variant</v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="10"
                 sm="11"
                 class="balance-callout-text">
            Balance shown may not include all fees. View Current Bill or Make a Payment to see total amount due.
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
  export default {
    name: 'BalanceCallout',
  };
</script>
<style lang="scss">
  .balance-callout-background {
    background-color: #C9DFEC !important;
  }

  .balance-callout-icon-column {
    align-content: center !important;
    margin: auto !important;
  }

  .theme--light.v-icon.mdi-information-variant {
    color: $white !important;
  }

  .balance-info-icon {
    background-color: $tfb-blue !important;
    border: 4px solid $tfb-blue !important;
    align-content: center !important;
    margin: auto !important;
    color: $white !important;
  }

  .balance-callout-text {
    color: $black !important;
    align-content: center !important;
  }
</style>
